import { useState } from 'react';
import { AdminDemoData } from '@platform/client';
import { AdminFormModal, ModalStage } from '../../AdminFormModal';

export const CreateDemoCommunityWinModal = (props: { onClose: () => void }) => {
  const [modalStage, setModalStage] = useState<ModalStage>('form');
  const [successText, setSuccessText] = useState<string>();

  const createCommunityWinMutator = AdminDemoData.useCreateDemoCommunityWin({
    mutation: {
      onMutate: () => setModalStage('submitting'),
      onError: () => setModalStage('error'),
      onSuccess: (data) => {
        setSuccessText(`Community win #${data.communityWinId} ("${data.title}") created.`);
        setModalStage('success');
      },
    },
  });

  return (
    <AdminFormModal
      title='Create Demo Community Win'
      onClose={props.onClose}
      modalStage={modalStage}
      successText={successText}
      submitCTA={{
        text: 'Create',
        callback: () => createCommunityWinMutator.mutate(),
      }}
    >
      <p className='text-sm text-gray-600'>
        Creates a realistic community win to show off on the community page — no configuration
        needed.
      </p>
    </AdminFormModal>
  );
};
